var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpreintecarbonne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101 80.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#edead9;}.cls-2,.cls-3,.cls-4{stroke:#5a0838;stroke-width:1.5px;}.cls-2,.cls-3{stroke-miterlimit:10;}.cls-3,.cls-4{fill:none;}.cls-4{stroke-linejoin:bevel;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Empreinte carbonne") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.38,80A31.33,31.33,0,0,1,22,63.85a21.54,21.54,0,0,1-.7-43.06A27.86,27.86,0,0,1,64.15,5.61,3.39,3.39,0,0,1,64.47,5a3.48,3.48,0,0,1,2.24-1.47A31.47,31.47,0,0,1,98.6,16.84a3.51,3.51,0,0,1-.94,4.86l-.83.56a3.48,3.48,0,0,1-.81.41A26,26,0,0,1,98.75,33c0,.44,0,.91,0,1.38a3.51,3.51,0,0,1-2.51,3.36A16.25,16.25,0,0,1,77.11,63.29,31.62,31.62,0,0,1,49.38,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.09,1A27.4,27.4,0,0,1,64.42,6.43,3,3,0,0,1,66.81,4a31,31,0,0,1,31.38,13.1,3,3,0,0,1-.8,4.16l-.83.56a3,3,0,0,1-1.27.48,25.6,25.6,0,0,1,3,10.73c0,.43,0,.89,0,1.35a3,3,0,0,1-3,3h0a15.75,15.75,0,0,1-18.35,25.2,30.84,30.84,0,0,1-54.64.73H22a21,21,0,0,1-.4-42.07A27.67,27.67,0,0,1,48.09,1m0-1A28.86,28.86,0,0,0,20.88,20.31a22,22,0,0,0,.79,44,31.84,31.84,0,0,0,55.66-.41A16.74,16.74,0,0,0,97.11,38a4,4,0,0,0,2.18-3.55c0-.48,0-1,0-1.41A26.46,26.46,0,0,0,96.7,22.92a3.93,3.93,0,0,0,.41-.24l.83-.56A4,4,0,0,0,99,16.56,32,32,0,0,0,66.63,3a4,4,0,0,0-2.56,1.68l-.1.15A28.59,28.59,0,0,0,48.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.14,37.93c0-.51.08-1,.08-1.56A19.55,19.55,0,0,0,70.67,16.82c-.55,0-1.09,0-1.62.08A23.89,23.89,0,0,0,24.45,25a17.54,17.54,0,1,0-.1,34.72,27.34,27.34,0,0,0,51-2.55,12.25,12.25,0,1,0,14.76-19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.55,12.18a22.24,22.24,0,0,1,22.2,21.07q0,.58,0,1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.46,7.47A27.47,27.47,0,0,1,95.29,19.08"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 52.29,
    cy: 39.53,
    r: 8.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.05,45.42A8.34,8.34,0,1,1,40,33.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M62.85,45.78a3.77,3.77,0,0,1,3.71-1.51c2.55.35,2.32,2.43,1.16,3.71s-4.86,4.63-4.86,4.63h6.37"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpreintecarbonne);
export default __webpack_public_path__ + "static/media/Empreinte carbonne.80ca079006181494f4dc80dc33d4bf25.svg";
export { ForwardRef as ReactComponent };